//export jQuery for outside use.
window.$ = $;

require("./populate-hero-nav.js")

require("./common.js")